import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ItemsTableFormatEnum} from "./items-table-format.enum";
import * as _ from "lodash";
import {ItemsTableActionEnum} from "./items-table-action.enum";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";


@Component({
  selector: 'lib-items-table-list',
  templateUrl: './items-table-list.component.html',
  styleUrls: ['./items-table-list.component.scss']
})
export class ItemsTableListComponent implements OnInit {

  @Input() items: any = [];
  @Input() tableHeaders: any[] = []
  @Input() showCheck: boolean = true;
  @Input() loading: boolean = false;
  @Input() showTablePaginator: boolean = true;
  @Input() htmlContainerClass: boolean = true;
  @Output() onOrderTable = new EventEmitter<any>();
  @Output() checkItemEvent = new EventEmitter<any>();
  @Output() checkAll = new EventEmitter<any>();
  @Output() onClickAction = new EventEmitter<any>();
  selectAll: boolean = false;
  count: number = 0;
  itemsSelected: any[] = [];

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.count = this.items.length;
  }

  addItemsToList() {
  }

  clickCheckAll(event: any) {
    const checked: boolean = event.target.checked;
    this.itemsSelected = _.map(this.items, item => {
      item.checked = checked;
      return item;
    });
    if (!checked) this.itemsSelected = []
    this.checkAll.emit({itemsSelected: this.itemsSelected, selectAll: event.target.checked})
  }

  addSingleItem(item: any) {
    const index = this.itemsSelected.indexOf(item);
    const indexItem = this.items.indexOf(item);
    this.items[indexItem].checked = !this.items[indexItem].checked;
    if (index === -1) {
      this.itemsSelected.push(item)
    } else {
      this.itemsSelected.splice(index, 1);
    }
    this.selectAll = false
    this.checkItemEvent.emit({itemsSelected: this.itemsSelected, selectAll: false})
  }

  onPageChange(event: any) {

  }

  orderTable(title: string) {
    this.onOrderTable.emit(title);
  }

  protected readonly ItemsTableFormatEnum = ItemsTableFormatEnum;
  protected readonly ItemsTableActionEnum = ItemsTableActionEnum;

  onAction(action: ItemsTableActionEnum, item: any) {
    this.onClickAction.emit({action, item})
  }


  isNumber(value: any) {
    return typeof value === 'number'
  }

  sanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
